import { gsap } from 'gsap';

const SELECTOR = {
    HTML: document.documentElement,
    MENU_BTN: document.getElementById('menu-btn'),
    HERO: document.querySelector('.hero'),
    IMG: document.querySelector('[data-hero-img]'),
    IMG_MENU: document.querySelector('[data-menu-img]'),
    LINES: [...document.querySelectorAll('[data-hero-line]')],
    HEADING_MAIN: document.querySelector('[data-hero-heading-main]'),
    HEADING_SUB: document.querySelector('[data-hero-heading-sub]'),
    COPY: document.querySelector('[data-hero-copy]'),
    RESERVE: document.querySelector('[data-reserve]'),
    NAV: document.querySelector('[data-nav-list]'),
    MENU_BUTTON: document.querySelector('[data-menu-btn]'),
}

const CLASSES = {
    LOADED: 'is-loaded',
    ACTIVE: 'active'
}

export default class Menu {
    constructor() {
        if (!SELECTOR.MENU_BTN) return;
        const observer = new MutationObserver(records => {
            if (SELECTOR.IMG_MENU.className.indexOf(CLASSES.ACTIVE) > -1) {
                gsap.killTweensOf($(SELECTOR.IMG_MENU))
                const ua = navigator.userAgent;
                if (ua.indexOf('iPhone') > -1 || (ua.indexOf('Android') > -1 && ua.indexOf('Mobile') > -1)) {
                    // スマートフォン
                    this.openingSP()
                } else if (ua.indexOf('iPad') > -1 || ua.indexOf('Android') > -1) {
                    // tab
                    this.opening();
                } else {
                    // pc
                    this.opening();
                }
            } else {
                gsap.killTweensOf($(SELECTOR.IMG_MENU))
                this.closing();
            }
        })

        observer.observe(SELECTOR.IMG_MENU, {
            attributes: true,
            attributeFilter: ['class']
        })

    };

    closing() {
        gsap.to(SELECTOR.IMG_MENU, {
            duration: 0.9,
            ease: 'power4.out',
            "clip-path": 'circle(0% at 85% 3%)'
        })
    }
    opening() {
        gsap.to(SELECTOR.IMG_MENU, {
            opacity: 1,
            duration: 0
        })
        gsap.fromTo(
            SELECTOR.IMG_MENU, {
                "clip-path": 'circle(0 at 85% 3%)'
            }, {
                "clip-path": 'circle(150% at 12% 100%)',
                ease: 'power4.out',
                duration: 2
            }
        )
    };

    openingSP() {
        gsap.to(SELECTOR.IMG_MENU, {
            opacity: 1,
            duration: 0
        })
        gsap.fromTo(
            SELECTOR.IMG_MENU, {
                "clip-path": 'circle(0 at 100% 3%)'
            }, {
                "clip-path": 'circle(150% at 12% 100%)',
                ease: 'power4.out',
                duration: 2
            }
        )
    };
}